import React from 'react';

/**
 * RadioField component - handles radio button group
 */
function RadioField({ field, index, value, onChange, formId }) {
    const fieldId = `${formId}_${field.name}_${index}`;

    return (
        <div className="space-y-2">
            {field.options && field.options.map((option, optIndex) => {
                const optionValue = typeof option === 'string' ? option : option.value;
                const optionLabel = typeof option === 'string' ? option : option.label;
                return (
                    <label key={optIndex} className="flex items-center">
                        <input
                            type="radio"
                            name={fieldId}
                            value={optionValue}
                            checked={value === optionValue}
                            onChange={(e) => onChange(index, e.target.value)}
                            className="mr-2"
                        />
                        <span className="text-sm text-content">{optionLabel}</span>
                    </label>
                );
            })}
        </div>
    );
}

export default RadioField;
